import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_partyIdAdapter2v7zx778kk10s as get_partyIdAdapter,
  get_pairingSetIdAdapter204jlhkjchobz as get_pairingSetIdAdapter,
} from '../../../adapter/Adapter.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { DeletePairAssignmentsInput11fmeg9pssfu8 as DeletePairAssignmentsInput } from '../DeletePairAssignmentsInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DeletePairAssignmentsInput_InputAdapterClass;
function DeletePairAssignmentsInput_InputAdapter() {
  if (DeletePairAssignmentsInput_InputAdapterClass === VOID) {
    class $ {
      s3x(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      r6s(writer, customScalarAdapters, value) {
        writer.n4a('partyId');
        get_partyIdAdapter().t3x(writer, customScalarAdapters, value.g6p_1);
        writer.n4a('pairingSetId');
        get_pairingSetIdAdapter().t3x(writer, customScalarAdapters, value.h6p_1);
      }
      t3x(writer, customScalarAdapters, value) {
        return this.r6s(writer, customScalarAdapters, value instanceof DeletePairAssignmentsInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'DeletePairAssignmentsInput_InputAdapter', VOID, VOID, [Adapter()]);
    DeletePairAssignmentsInput_InputAdapterClass = $;
  }
  return DeletePairAssignmentsInput_InputAdapterClass;
}
var DeletePairAssignmentsInput_InputAdapter_instance;
function DeletePairAssignmentsInput_InputAdapter_getInstance() {
  return DeletePairAssignmentsInput_InputAdapter_instance;
}
//region block: init
DeletePairAssignmentsInput_InputAdapter_instance = new (DeletePairAssignmentsInput_InputAdapter())();
//endregion
//region block: exports
export {
  DeletePairAssignmentsInput_InputAdapter_instance as DeletePairAssignmentsInput_InputAdapter_instance1jcef61saqjm4,
};
//endregion

//# sourceMappingURL=DeletePairAssignmentsInput_InputAdapter.mjs.map
